import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getImageSrc } from 'wix-rich-content-common/libs/imageUtils';
import { SettingsMobileHeader, SettingsPanelHeader, SettingsSection, Image, Loader, InputWithLabel, SettingsPanelFooter, SettingsSeparator, LabeledToggle } from 'wix-rich-content-ui-components';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { DIVIDER } from '../consts.js';
import { SETTINGS_MODAL } from '../dataHooks.js';
import 'ricos-schema';

var css_248z = ".qBQFY{color:var(--ricos-settings-text-color,#333);display:flex;flex:1 1 auto;flex-direction:column;position:unset;z-index:5}[dir] .qBQFY{background:#fff}[dir=ltr] .qBQFY{left:0;right:0;text-align:left}[dir=rtl] .qBQFY{left:0;right:0;text-align:right}.odmwQ{font-size:20px;position:absolute}[dir=ltr] .odmwQ{margin:24px 0 24px 24px}[dir=rtl] .odmwQ{margin:24px 24px 24px 0}[dir] ._4M1-a{padding:0 24px}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] ._4M1-a{padding:20px 20px 0}}}@container (width < 640px){[dir] ._4M1-a{padding:20px 20px 0}}._3UHGe{display:flex;height:240px;justify-content:center;width:100%}[dir] ._3UHGe{background-color:rgba(51,51,51,.1)}.rYaxk{font-size:14px;position:relative}[dir] .rYaxk{padding:20px 0 0}[dir] .n50wV{margin-bottom:5px}.y0ezH{height:calc(100% - 170px);overflow:scroll;position:absolute;top:70px;width:100%}[dir] .y0ezH{margin:0;padding-bottom:30px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.y0ezH{height:calc(100% - 50px);top:50px}}}@container (width < 640px){.y0ezH{height:calc(100% - 50px);top:50px}}[dir] .Y7nCo{padding:0 24px}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] .Y7nCo{padding:0 20px}}}@container (width < 640px){[dir] .Y7nCo{padding:0 20px}}[dir] .sfljI{margin:0 auto}.BWq4d{z-index:6}._7Yt6J{visibility:hidden}";
var styles = {"imageSettings":"qBQFY","imageSettingsTitle":"odmwQ","imageSettingsImageSection":"_4M1-a","imageSettingsImage":"_3UHGe","imageSettingsSection":"rYaxk","imageSettingsLabel":"n50wV","imageSettings_scrollContainer":"y0ezH","imageSettings_inputsWrapper":"Y7nCo","imageSettings_mobile":"sfljI","imageSettings_footer":"BWq4d","imageSettings_hidden":"_7Yt6J"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class ImageSettings extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "renderToggle", ({ isChecked, toggleKey, labelKey, dataHook, tooltipText, onChange, type }) => {
      const { t } = this.props;
      return type === DIVIDER ? /* @__PURE__ */ React.createElement(SettingsSeparator, { key: toggleKey, top: true }) : /* @__PURE__ */ React.createElement("div", { key: toggleKey, className: styles.imageSettings_toggleContainer }, /* @__PURE__ */ React.createElement(
        LabeledToggle,
        {
          checked: isChecked(),
          label: t(labelKey),
          onChange,
          dataHook,
          tooltipText
        }
      ));
    });
    __publicField(this, "baseToggleData", [
      {
        toggleKey: "isExpandEnabled",
        labelKey: "ImagePlugin_Settings_ImageOpensInExpandMode_Label",
        dataHook: "imageExpandToggle",
        tooltipText: this.props.t("ImageSettings_Expand_Mode_Toggle"),
        isChecked: () => !this.props.componentData.disableExpand,
        onChange: () => this.props.updateData({
          disableExpand: !this.props.componentData.disableExpand
        })
      },
      {
        toggleKey: "isDownloadEnabled",
        labelKey: "ImagePlugin_Settings_ImageCanBeDownloaded_Label",
        dataHook: "imageDownloadToggle",
        tooltipText: this.props.t("ImagePlugin_Settings_ImageCanBeDownloaded_Tooltip"),
        isChecked: () => !this.props.componentData.disableDownload,
        onChange: () => this.props.updateData({
          disableDownload: !this.props.componentData.disableDownload
        })
      }
    ]);
    __publicField(this, "toggleData", this.props.shouldShowSpoiler ? [
      ...this.baseToggleData,
      {
        type: DIVIDER
      },
      {
        toggleKey: "isSpoilerEnabled",
        labelKey: "ImageSettings_Spoiler_Toggle",
        dataHook: "imageSpoilerToggle",
        tooltipText: this.props.t("Spoiler_Toggle_Tooltip"),
        isChecked: () => {
          var _a, _b;
          return (_b = (_a = this.props.componentData.containerData) == null ? void 0 : _a.spoiler) == null ? void 0 : _b.enabled;
        },
        onChange: () => {
          var _a, _b;
          return this.props.updateData(__spreadProps(__spreadValues({}, this.props.componentData), {
            containerData: __spreadProps(__spreadValues({}, this.props.componentData.containerData), {
              spoiler: { enabled: !((_b = (_a = this.props.componentData.containerData) == null ? void 0 : _a.spoiler) == null ? void 0 : _b.enabled) }
            })
          }));
        }
      }
    ] : this.baseToggleData);
    const { t } = props;
    this.updateLabel = t("ImageSettings_Update");
    this.headerText = t("ImageSettings_Header");
    this.captionLabel = t("ImageSettings_Caption_Label");
    this.captionInputPlaceholder = t("ImageSettings_Caption_Input_Placeholder");
    this.altLabel = t("ImageSettings_Alt_Label");
    this.altTooltip = "ImageSettings_Alt_Label_Tooltip";
    this.altInputPlaceholder = t("ImageSettings_Alt_Input_Placeholder");
  }
  render() {
    const { helpers, t, isMobile, languageDir, onCancel, onSave, componentData, updateData } = this.props;
    const { image, error, altText, caption } = componentData;
    const imageSrc = image.src.id || image.src.url;
    const srcObj = {
      file_name: imageSrc,
      id: imageSrc,
      width: image.width,
      height: image.height
    };
    const imgError = error ? {
      message: error,
      t
    } : void 0;
    const imageWidth = 1e3;
    const imageHeight = 240;
    const displayedImageWidth = image.width && image.height ? image.width * (imageHeight / image.height) : imageWidth;
    return /* @__PURE__ */ React.createElement("div", { className: styles.imageSettings, "data-hook": "settings", dir: languageDir }, isMobile ? /* @__PURE__ */ React.createElement(
      SettingsMobileHeader,
      {
        onCancel,
        onSave,
        t,
        title: t("ImageSettings_Header")
      }
    ) : /* @__PURE__ */ React.createElement(SettingsPanelHeader, { title: this.headerText, onClose: onCancel }), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(styles.imageSettings_scrollContainer, {
          [styles.imageSettings_mobile]: isMobile
        })
      },
      /* @__PURE__ */ React.createElement(
        SettingsSection,
        {
          className: styles.imageSettingsImageSection,
          ariaProps: {
            "aria-label": "image preview",
            role: "region",
            "data-hook": SETTINGS_MODAL.IMAGE_PREVIEW
          }
        },
        srcObj ? /* @__PURE__ */ React.createElement("div", { className: styles.imageSettingsImage }, /* @__PURE__ */ React.createElement(
          Image,
          {
            alt: altText || t("ImagePlugin_Image_Preview_Alt"),
            displayMode: "fit",
            uri: getImageSrc(srcObj, helpers == null ? void 0 : helpers.getImageUrl, {
              requiredWidth: imageWidth,
              requiredHeight: imageHeight,
              requiredQuality: 80
            }),
            width: displayedImageWidth,
            height: imageHeight,
            error: imgError,
            containerProps: {
              style: {
                width: `${displayedImageWidth}px`,
                height: `${imageHeight}px`
              }
            }
          }
        )) : /* @__PURE__ */ React.createElement("div", { className: styles.imageSettingsImage }, /* @__PURE__ */ React.createElement(Loader, { type: "medium" }))
      ),
      /* @__PURE__ */ React.createElement("div", { className: styles.imageSettings_inputsWrapper }, /* @__PURE__ */ React.createElement(
        SettingsSection,
        {
          className: styles.imageSettingsSection,
          ariaProps: { "aria-label": "image caption", role: "region" }
        },
        /* @__PURE__ */ React.createElement(
          InputWithLabel,
          {
            id: "imageSettingsCaptionInput",
            label: this.captionLabel,
            placeholder: this.captionInputPlaceholder,
            value: caption || "",
            onChange: (caption2) => updateData({ caption: caption2 }),
            dataHook: SETTINGS_MODAL.CAPTION_INPUT
          }
        )
      ), /* @__PURE__ */ React.createElement(
        SettingsSection,
        {
          className: styles.imageSettingsSection,
          ariaProps: { "aria-label": "image alt text", role: "region" }
        },
        /* @__PURE__ */ React.createElement(
          InputWithLabel,
          {
            id: "imageSettingsAltInput",
            label: this.altLabel,
            placeholder: this.altInputPlaceholder,
            t,
            value: altText || "",
            onChange: (altText2) => updateData({ altText: altText2 }),
            dataHook: SETTINGS_MODAL.ALT_INPUT_TEXT,
            tooltipTextKey: this.altTooltip,
            isMobile
          }
        )
      ), /* @__PURE__ */ React.createElement(
        SettingsSection,
        {
          ariaProps: { "aria-label": "link redirect explanation", role: "region" }
        },
        /* @__PURE__ */ React.createElement("div", { className: styles.imageSettingsLabel }, this.toggleData.map((toggle) => this.renderToggle(toggle)))
      ))
    ), !isMobile && /* @__PURE__ */ React.createElement(SettingsPanelFooter, { fixed: true, cancel: onCancel, save: onSave, t }));
  }
}
ImageSettings.propTypes = {
  componentData: PropTypes.any.isRequired,
  helpers: PropTypes.object,
  experiments: PropTypes.object,
  t: PropTypes.func,
  isMobile: PropTypes.bool,
  languageDir: PropTypes.string,
  shouldShowSpoiler: PropTypes.bool,
  updateData: PropTypes.func,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
  getComponentData: PropTypes.func
};

export { ImageSettings as default };
//# sourceMappingURL=image-settings.js.map
